// CONSTANTS are all caps.
const NS = 'ShoppingCartItem';
const CLS = 'shoppingCartItem';
const WG = '.' + CLS + '-';
const CLS_IS_ACTIVE = "is-active";
const CLS_INVISIBLE = "invisible";
const CLS_HIDE = "d-none";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/shoppingCartItem.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import * as utils from '../../../../global/js/utils';
import * as Api from '../../../../global/js/api';
import * as wishlist from '../../../../global/js/wishlist';
import * as checkout from '../../../../global/js/checkout';
import {handleDiscountView, handleCouponShipping, updatePriceItem, refreshBonusBuyBadge, splitEmailEgiftCard} from '../../../../global/js/cart';
import {updateHeaderCart} from '../../headerCart/js/headerCart';
import {updatePomotional} from '../../../blocks/promotionalList/js/promotionalList';

export class ShoppingCartItem {
	constructor($el) {
		// $el is the widget node return by the loadShoppingCartItem function
		this.$el = $el;
	}

	init() {
		this.setShoppingCartItem();
	}

	setShoppingCartItem() {
		// Add Some logic here
		const $wg = $(this.$el);
		const This = this;
		let $itemOverlay = $wg.find('.remove-item-overlay');
		const $emailList = $('.email-split');
		if ($emailList.length) {
			$emailList.each(function(index, el) {
				splitEmailEgiftCard($(el), 40, 40);
			});
		}

		let updateFun = () => {
			let isWishlist = $wg.hasClass(`${CLS}--wishlist`);
			let $currentVal = $wg.find('.quantityInput input').val();
			let $prevQuantity = $wg.data('prevQuantity');

			if (isWishlist) {
				This.updateWishlistQuantity($currentVal);
			} else {
				This.updateItemQuantity($currentVal);
			}

			$wg.data('prevQuantity', $currentVal);
		};

		$wg.on('click', '.item-remove-btn', function() {
			$itemOverlay.addClass('is-active');
		});

		$wg.on('click', '.cancel-button', function() {
			$itemOverlay.removeClass('is-active');
		});

		$wg.on('click', '.remove-confirm', function() {
			let isWishlist = $wg.hasClass(`${CLS}--wishlist`);

			if (isWishlist) {
				This.removeWishlistItem($(this));
			} else {
				This.removeCartItem();
			}
		});

		$wg.on('click', '.quantityInput-up:not(.disabled), .quantityInput-down:not(.zero)', function() {
			updateFun();
		});

		// update Qty on enter
		$wg.on('keyup', '.quantityInput input.form-control', function(e) {
			if (e.keyCode === 13) {
				updateFun();
			}
		});

		$wg.on('click', '.quantityInput-down.zero', function() {
			$itemOverlay.addClass('is-active');
		});

		// handle move to cart
		$wg.on('click', `${WG}moveToCartBtn`, function () {
			$wg.find(`${WG}moveToCartOverlay`).addClass('is-active');
		});

		$wg.on('click', `${WG}moveToCartCancel`, function () {
			$wg.find(`${WG}moveToCartOverlay`).removeClass('is-active');
		});

		$wg.on('click', `${WG}moveToCartConfirm`, function () {
			This.moveToCart();
		});
		// end of handle move to cart
	}

	updateItemQuantity($currentVal) {
		const $wg = $(this.$el);
		const This = this;
		const $error = $wg.find('.error-messages');

		// toggle spinners
		utils.showLoading();

		$error.text('');
		$error.removeClass(CLS_IS_ACTIVE);

		This.updateItemQuantityCall().then((data) => {
			if (data.result == 'SUCCESS') {
				if (data.quantity < Number($currentVal)) {
					// the updated quantity cannot exceede the data.quantity
					$wg.find('.quantityInput input').val(data.quantity);
					$wg.find('.quantityInput .btn-up').addClass('disabled');
					utils.hideLoading();
				} else {
					$wg.find('.quantityInput .btn-up').removeClass('disabled');
				}
				let res = data.response;
				// get values and the item updated
				let itemId = res.itemcode || null;
				let itemTotal = res.extendedprice || 0;
				let taxes = res.totaltaxes || 0;
				let subtotal = res.subtotal || 0;
				let total = res.total || 0;
				let totalWithoutShipping = res.totalWithoutShipping || 0;
				let cartCount = res.lineitemscount || 0;
				let item = $('.shoppingCartItem[data-id=' + itemId + ']');
				let discounttotal = res.discounttotal || '0';
				let couponCodes = res.couponCodes || [];
				let shippingTotal = res.shippingTotal || 0;
				let shippingCouponCode = res.shippingCouponCode || '';
				$(document).find('.shipping-value').text('$' + parseFloat(shippingTotal).toFixed(2));
				// update markup on the item
				item.find('.item-total').text('$' + parseFloat(itemTotal).toFixed(2));
				// update markup on the totals summary
				$(document).find('.subtotal-value').text('$' + parseFloat(subtotal).toFixed(2));
				$(document).find('.tax-value').text('$' + parseFloat(taxes).toFixed(2));
				$(document).find('.total-value').text('$' + parseFloat(total).toFixed(2));
				$(document).find('.total-without-shipping').text('$' + parseFloat(totalWithoutShipping).toFixed(2));

				$(document).find('.siteHeader-subTotal').text(' = $' + parseFloat(subtotal).toFixed(2));
				$(document).find('.js-cartCount').text(cartCount);

				// Sync shopping cart to header cart
				updateHeaderCart(cartCount);

				updatePomotional(res.freeOrDiscountedPromotionalItems, res.lineItemPrices);
				handleDiscountView(discounttotal, couponCodes);
				handleCouponShipping(shippingCouponCode);
				updatePriceItem(res);
				refreshBonusBuyBadge(data.response.lineItemPrices, $('.shoppingCartItem'));
				const url = $wg.data('get-stock-data-url');
				if (url) {
					checkout.updateStockData({
						url,
					}).then(utils.hideLoading).catch(utils.hideLoading);
				} else {
					utils.hideLoading();
				}

				if (data.message) {
					$error.addClass(CLS_IS_ACTIVE).text(data.message);
				}
			} else {
				// show error div
				$error.addClass(CLS_IS_ACTIVE).text(data.message);
				utils.hideLoading();
			}
		});
	}

	gtmRemoveFromCart(productObj) {
		// Measure the removal of a product from a shopping cart.
		window.dataLayer = window.dataLayer || [];
		// defined in the root file
		let datasource = datalayerDataSource || [];
		let result = datasource.find((obj) => {
			return obj.code === productObj.code;
		});

		if (result) {
			window.dataLayer.push({
				'event': 'removeFromCart',
				'ecommerce': {
					'remove': { // 'add' actionFieldObject measures.
						'products': [{ // adding a product to a shopping cart.
							'name': result.name,
							'id': result.id,
							'price': result.price,
							'brand': result.brand,
							'category': result.category,
							'variant': result.colour,
							'dimension5': result.size,
							'dimension6': result.stock,
							'dimension7': result.priceType,
							'quantity': productObj.quantity,
						}],
					},
				},
			});
		}
	}

	removeCartItem() {
		const $wg = $(this.$el);
		const This = this;

		// toggle spinners
		utils.showLoading();

		This.removeCartItemCall().then((data) => {
			if (data.result == 'SUCCESS') {
				let res = data.response;
				// get values and the item updated
				let itemId = res.itemcode || null;
				let taxes = res.totaltaxes || 0;
				let subtotal = res.subtotal || 0;
				let total = res.total || 0;
				let totalWithoutShipping = res.totalWithoutShipping || 0;
				let cartCount = res.lineitemscount || 0;
				let discounttotal = res.discounttotal || '0';
				let couponCodes = res.couponCodes || [];
				let item = $('.shoppingCartItem[data-id=' + itemId + ']');
				let shippingTotal = res.shippingTotal || 0;
				let shippingCouponCode = res.shippingCouponCode || '';
				let $cartCount = $(document).find('.siteHeader-cart .js-cartCount');

				$(document).find('.shipping-value').text('$' + parseFloat(shippingTotal).toFixed(2));
				// update markup on the totals summary
				$(document).find('.subtotal-value').text('$' + parseFloat(subtotal).toFixed(2));
				$(document).find('.tax-value').text('$' + parseFloat(taxes).toFixed(2));
				$(document).find('.total-value').text('$' + parseFloat(total).toFixed(2));
				$(document).find('.total-without-shipping').text('$' + parseFloat(totalWithoutShipping).toFixed(2));
				$(document).find('.discounttotal-value').text('-$' + parseFloat(discounttotal).toFixed(2));

				handleDiscountView(discounttotal, couponCodes);
				handleCouponShipping(shippingCouponCode);
				if ($cartCount.length > 0) {
					$(document).find('.siteHeader-subTotal').text(' = $' + parseFloat(subtotal).toFixed(2));
					$cartCount.text(cartCount);
				}

				// Sync shopping cart to header cart
				updateHeaderCart(cartCount);

				updatePomotional(res.freeOrDiscountedPromotionalItems, res.lineItemPrices);
				updatePriceItem(res);

				// remove the item
				$wg.find('.remove-item-overlay').removeClass('is-active');
				// remove from cart (use the id returned by the fetch call)
				item.fadeOut(500, function() {
					$(this).remove();
					// check remaining items
					let cartItems = $('.shoppingCartItem').length;
					if (cartItems == 0) {
						$(document).find('.shipping-value').text('$' + '0.00');
						$(document).find('.no-cart-items').removeClass('d-none');
						// disabled continue button
						$(document).find('.checkout-btn')
							.attr({'href': 'javascript:void(0)'})
							.addClass('is-disabled-link');
						$cartCount.addClass(CLS_INVISIBLE);
					}
					refreshBonusBuyBadge(data.response.lineItemPrices, $('.shoppingCartItem'));
				});

				// send dataLayer to Google Tag Manager
				let quantity = $wg.find('.quantityInput input').val();
				let productObj = {
					code: itemId,
					quantity: quantity,
				};
				This.gtmRemoveFromCart(productObj);
				const url = $wg.data('get-stock-data-url');
				if (url && cartCount > 0) {
					checkout.updateStockData({
						url,
					}).then(utils.hideLoading).catch(utils.hideLoading);
				} else {
					utils.hideLoading();
				}

				This.hideDonate(cartCount);
			} else {
				// show error div
				$wg.find('.remove-item-overlay').removeClass('is-active');
				$wg.find('.error-messages').addClass('is-active').text(data.message);
				utils.hideLoading();
			}
		});
	}

	hideDonate(cartCount) {
		const $donate = $('.donate');
		const notDonate = !$donate.find('.donate-radio:checked').length;
		if (cartCount == 0 && notDonate) {
			$('.donate').hide();
		}
	}

	removeCartItemCall() {
		const $wg = $(this.$el);
		let $removeItemApiEndpoint = $wg.data('removeItemApiEndpoint');
		let $itemId = $wg.data('id');
		let $data = {
			'id': $itemId,
		};

		return Api.callApi($removeItemApiEndpoint, $data);
	}

	updateItemQuantityCall() {
		const $wg = $(this.$el);
		let $quantity = $wg.find('.quantityInput input').val();
		let $updateItemApiEndpoint = $wg.data('updateItemApiEndpoint');
		let $itemId = $wg.data('id');
		let $data = {
			'id': $itemId,
			'quantity': $quantity,
		};

		return Api.callApi($updateItemApiEndpoint, $data);
	}

	removeWishlistItem($btn) {
		const $wg = $(this.$el);
		const This = this;
		let $itemId = $wg.data('id');
		let param = {
			code: $itemId,
		};

		let removeEndpoint = $wg.data('removeItemApiEndpoint');
		wishlist.remove($wg, $btn, removeEndpoint, param, (resp) => {
			This.removeWishlistItemCB();
		});
	}

	moveToCart() {
		const $wg = $(this.$el);
		const This = this;
		let $endpoint = $wg.data('moveItemApiEndpoint');
		let $itemId = $wg.data('code');
		let $quantity = $wg.find('.quantityInput input').val();
		let $data = {
			'id': $itemId,
			'quantity': $quantity,
		};

		wishlist.moveToCart($wg, $endpoint, $data, (data) => {
			// movedCB
			let $cartCount = $(document).find('.siteHeader-cart .js-cartCount');
			$cartCount.removeClass(CLS_INVISIBLE).html(data.response.cartCount);
			This.removeWishlistItemCB();
			// Sync shopping cart to header cart
			updateHeaderCart(data.response.cartCount);
		});
	}

	updateWishlistQuantity($currentVal) {
		const $wg = $(this.$el);
		let $endpoint = $wg.data('updateItemApiEndpoint');
		let $itemId = $wg.data('id');
		let $quantity = $wg.find('.quantityInput input').val();
		let $data = {
			'id': $itemId,
			'quantity': $quantity,
		};

		wishlist.updateQuantity($wg, $endpoint, $data, (resp) => {
			//updatedCB
			if (resp.quantity < Number($currentVal)) {
				// the updated quantity cannot exceede the resp.quantity
				$wg.find('.quantityInput input').val(resp.quantity);
				$wg.find('.quantityInput .btn-up').addClass('disabled');
			} else {
				$wg.find('.quantityInput .btn-up').removeClass('disabled');
			}

			$wg.find('.itemSubTotal').text('$' + resp.response.extendedprice);
		});
	}

	removeWishlistItemCB() {
		const $wg = $(this.$el);
		$wg.fadeOut(500, function() {
			$(this).remove();

			// check if there's any wishist item
			let items = $('.shoppingCartItem');
			if (items.length === 0) {
				$(document).find('.wishlistPage-empty').removeClass(CLS_HIDE);
				$(document).find('.wishlistPage-moveAllBtn').addClass(CLS_HIDE);
			}
		});
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/src/views/widgets/shoppingCartItem/js/shoppingCartItem.js